import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { GitHubAppRepoPickerField } from './GitHubAppRepoPickerField';

export const GitHubAppRepoPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GitHubAppRepoPicker',
    component: GitHubAppRepoPickerField,
  }),
);
